// extracted by mini-css-extract-plugin
export default {"man":"man_man__mzBTV","icon":"man_icon__qiMI2","negative":"man_negative__M+V23"};